import React, { useState } from 'react';
import { Brain, CheckCircle2, Award, AlertTriangle, Sparkles, BarChart2 } from 'lucide-react';

export const VBMAPPModule: React.FC = () => {
  const [mandScore, setMandScore] = useState(4.5);
  const [tactScore, setTactScore] = useState(3.0);
  const [echoicScore, setEchoicScore] = useState(4.0);
  const [intraverbalScore, setIntraverbalScore] = useState(2.5);

  const totalScore = (mandScore + tactScore + echoicScore + intraverbalScore).toFixed(1);

  return (
    <div className="p-6 space-y-6 bg-slate-900 text-white rounded-2xl">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-800 pb-4">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-amber-500/20 text-amber-300 text-xs font-bold rounded-full border border-amber-500/30">
            <Brain className="w-3.5 h-3.5" /> Module 25: VB-MAPP & ABLLS-R Assessment Engine
          </div>
          <h2 className="text-2xl font-black mt-2">Verbal Behavior Milestones & Barrier Assessment</h2>
        </div>
        <div className="text-right">
          <div className="text-2xl font-black text-amber-400 font-mono">{totalScore} / 20</div>
          <div className="text-xs text-slate-400">Total VB-MAPP Milestone Score</div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-slate-950 p-5 rounded-2xl border border-slate-800 space-y-4">
          <h3 className="text-sm font-bold text-slate-200 flex items-center gap-2">
            <BarChart2 className="w-4 h-4 text-amber-400" /> Milestone Domain Assessment Rubric
          </h3>

          <div className="space-y-3">
            <div>
              <div className="flex justify-between text-xs text-slate-400 mb-1">
                <span>Mand (Requesting Desires)</span>
                <span className="font-bold text-amber-300">{mandScore} / 5</span>
              </div>
              <input type="range" min="0" max="5" step="0.5" value={mandScore} onChange={(e) => setMandScore(parseFloat(e.target.value))} className="w-full accent-amber-500 cursor-pointer" />
            </div>

            <div>
              <div className="flex justify-between text-xs text-slate-400 mb-1">
                <span>Tact (Labeling Objects)</span>
                <span className="font-bold text-amber-300">{tactScore} / 5</span>
              </div>
              <input type="range" min="0" max="5" step="0.5" value={tactScore} onChange={(e) => setTactScore(parseFloat(e.target.value))} className="w-full accent-amber-500 cursor-pointer" />
            </div>

            <div>
              <div className="flex justify-between text-xs text-slate-400 mb-1">
                <span>Echoic (Vocal Imitation)</span>
                <span className="font-bold text-amber-300">{echoicScore} / 5</span>
              </div>
              <input type="range" min="0" max="5" step="0.5" value={echoicScore} onChange={(e) => setEchoicScore(parseFloat(e.target.value))} className="w-full accent-amber-500 cursor-pointer" />
            </div>

            <div>
              <div className="flex justify-between text-xs text-slate-400 mb-1">
                <span>Intraverbal (Conversational Responses)</span>
                <span className="font-bold text-amber-300">{intraverbalScore} / 5</span>
              </div>
              <input type="range" min="0" max="5" step="0.5" value={intraverbalScore} onChange={(e) => setIntraverbalScore(parseFloat(e.target.value))} className="w-full accent-amber-500 cursor-pointer" />
            </div>
          </div>
        </div>

        <div className="bg-slate-950 p-5 rounded-2xl border border-slate-800 space-y-4">
          <h3 className="text-sm font-bold text-slate-200 flex items-center gap-2">
            <AlertTriangle className="w-4 h-4 text-orange-400" /> Automated Barrier Score Analysis
          </h3>
          <div className="p-4 bg-slate-900 rounded-xl border border-slate-800 space-y-2 text-xs text-slate-300">
            <div className="flex items-center justify-between font-bold text-amber-400">
              <span>Instructional Control Barrier:</span>
              <span>Low (1/5)</span>
            </div>
            <div className="flex items-center justify-between font-bold text-emerald-400">
              <span>Prompt Dependency Barrier:</span>
              <span>Moderate (2/5)</span>
            </div>
            <p className="text-[11px] text-slate-400 pt-2 border-t border-slate-800">
              BCBA Recommendation: Focus next 10 trials on fading vocal prompts during intraverbal WH-question responses.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
